import { render, staticRenderFns } from "./user_head.vue?vue&type=template&id=d89e5822&scoped=true&"
import script from "./user_head.vue?vue&type=script&lang=js&"
export * from "./user_head.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d89e5822",
  null
  
)

export default component.exports